import { useSelector } from "react-redux";
import { fromJS } from "immutable";

import { CRM_CHAT_FORCE_AGENT_LOOP_KEY } from "../constants/chatConstants";

/**
 * Subscription entitlement for multi-turn agent loop (story 3.13).
 * Optional QA: sessionStorage `crm-chat:force-agent-loop=1` (staging only).
 */
export function useChatAgentLoopFlag(): boolean {
  const userLimit =
    useSelector((state: { billingReducer?: { get: (k: string) => unknown } }) =>
      state.billingReducer?.get("userLimit")
    ) || fromJS({});

  const entitled =
    userLimit.getIn(["entitlements", "featuresEnabled", "chatAgentLoop"]) === true;

  let qaOverride = false;
  try {
    qaOverride =
      typeof window !== "undefined" &&
      window.sessionStorage.getItem(CRM_CHAT_FORCE_AGENT_LOOP_KEY) === "1";
  } catch {
    qaOverride = false;
  }

  return entitled || qaOverride;
}
